import DarkMode from "@mui/icons-material/DarkMode";
import LightMode from "@mui/icons-material/LightMode";
import { Tooltip } from "@mui/material";
import { Button, type ButtonSize } from "@src/appV2/redesign/components/Button";
import { useThemeMode } from "@src/appV2/UserPreferences/UserPreferencesProvider";

interface ThemeModeToggleProps {
  size?: ButtonSize;
}

export function ThemeModeToggle(props: ThemeModeToggleProps) {
  const { size = "medium" } = props;
  const { themeMode, toggleThemeMode } = useThemeMode();
  const isDark = themeMode === "dark";
  const iconFontSize = size === "large" ? "medium" : "small";

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <Button
        variant="link"
        size={size}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        sx={(theme) => ({
          minWidth: "unset",
          padding: theme.size?.button[size].paddingY,
          // Toggle sits on the navbar/header surface, which flips with theme.
          // Track that surface so the icon always has contrast.
          color: theme.palette.navbar?.itemContentSelected,
          "&:hover": {
            color: theme.palette.navbar?.itemContentSelected,
          },
        })}
        onClick={toggleThemeMode}
      >
        {isDark ? <LightMode fontSize={iconFontSize} /> : <DarkMode fontSize={iconFontSize} />}
      </Button>
    </Tooltip>
  );
}
